import { DataTable } from "@/components/DataTable";
import { TableWrapper } from "@/components/TableWrapper";
import { getSosEntityLineItemHashId } from "@/components/SosEntityLineItemHashLink";
import { withJobTrackingData } from "../withJobTrackingData";
import { buildTableColumns, BuildTableRow } from "./builds-table-columns";

export const Builds = withJobTrackingData(({ builds }) => {
  // Flatten the list of builds into a list of table rows (one row for each input/output line item)
  const data = builds.flatMap<BuildTableRow>((build) => {
    const numLines = Math.max(build.inputs.length, build.outputs.length);
    return Array.from({ length: numLines }, (_, index) => {
      const input = build.inputs[index];
      const output = build.outputs[index];
      return {
        rowId: getSosEntityLineItemHashId("build", build.id, index),
        build,
        input: input,
        output: output,
        numLines,
        isFirstLine: index === 0,
      };
    });
  });

  return (
    <TableWrapper className="col">
      <DataTable
        bordered
        hover
        data={data}
        columns={buildTableColumns}
        getRowId={({ rowId }) => rowId}
        initialState={{
          sorting: [{ id: "build_date", desc: true }],
        }}
      />
    </TableWrapper>
  );
});
